module.exports = __webpack_public_path__ + "img/wordBg2.a2093396.png";